import { FadeIn } from './fade-in';

interface Feature {
  number: string;
  title: string;
  description: string;
  image: string;
}

interface ProductKeyFeaturesSectionProps {
  title: string;
  features: Feature[];
}

export const ProductKeyFeaturesSection = ({
  title,
  features,
}: ProductKeyFeaturesSectionProps) => {
  return (
    <section className="relative w-full bg-neutral-1 pb-10 md:pb-[120px] min-h-[800px]">
      <div className="sticky top-[40px] md:top-[80px] z-20 bg-neutral-1 px-4 md:px-20 pt-10 md:pt-[120px] pb-5 md:pb-10">
        <FadeIn>
          <p className="text-2xl md:text-[40px] font-medium text-black">
            {title}
          </p>
        </FadeIn>
      </div>
      <div className="relative">
        {features.map((feature, index) => (
          <div
            key={`${feature.title}-${index}`}
            className="bg-neutral-1 px-4 md:px-20 top-[150px] sticky md:top-[298px]"
            style={{
              zIndex: index + 1,
            }}
          >
            <div className="h-px bg-black/10 w-full mb-6 md:mb-0" />

            <div className="flex flex-col lg:flex-row md:pt-[24px] md:pb-[60px] md:justify-between gap-6 md:gap-8">
              <div className="flex flex-col gap-6 lg:gap-0 text-black lg:flex-1">
                <FadeIn>
                  <div className="flex flex-col gap-3 xl:gap-[24px] lg:flex-row">
                    <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase lg:w-[105px] xl:shrink-0">
                      {feature.number}
                    </p>
                    <p className="font-medium text-xl leading-[1.4] lg:w-[233px] xl:shrink-0">
                      {feature.title}
                    </p>
                    <p className="text-base font-normal leading-[1.5] tracking-[0.16px] lg:max-w-[300px]">
                      {feature.description}
                    </p>
                  </div>
                </FadeIn>
              </div>

              <div className="w-full aspect-[343/292] mb-[60px] lg:mb-0 md:aspect-auto lg:h-[292px] lg:w-[512px] lg:shrink-0">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
